function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_255",
  "data-name": "Trazado 255",
  d: "M0,0H18V18H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_256",
  "data-name": "Trazado 256",
  d: "M5.839,15.667A1.638,1.638,0,0,0,7.518,17.25h6.714a1.638,1.638,0,0,0,1.679-1.583V7.75a1.638,1.638,0,0,0-1.679-1.583H7.518A1.638,1.638,0,0,0,5.839,7.75ZM15.911,3.792h-2.1l-.6-.562A.873.873,0,0,0,12.629,3H9.121a.873.873,0,0,0-.587.23l-.6.562h-2.1A.819.819,0,0,0,5,4.583a.819.819,0,0,0,.839.792H15.911a.819.819,0,0,0,.839-.792A.819.819,0,0,0,15.911,3.792Z",
  transform: "translate(-1.875 -1.125)",
  fill: "#050358"
});

var SvgDelete24Px = function SvgDelete24Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-24px",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete24Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-24px.21920a32.svg";
export { ForwardRef as ReactComponent };